import React, { useState, useEffect, useRef } from 'react';
import useAsync from '../hooks/useAsync';
import AdminServices from '../services/AdminServices';

function Profile() {
  const { data, error, isLoading, run } = useAsync(AdminServices.getMyProfile);
  const [formValues, setFormValues] = useState({
    mobileNo: '',
    name: '',
    email: '',
  });

  const [formValues2, setFormValues2] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const fileInputRef = useRef(null);

  // Update form values when data is fetched
  useEffect(() => {
    if (data) {
      // Check if data has the expected structure before updating form values
      setFormValues({
        mobileNo: data?.data?.mobileNo || '',
        name: data?.data?.name || '',
        email: data?.data?.email || '',
      });

      if (data?.data?.image) {
        setPreviewUrl(data?.data?.image); // If profile image URL exists in data
      }
    }
  }, [data]);
 
  // Handle form input changes for personal details
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  // Handle form input changes for password change
  const handleInputChange2 = (event) => {
    const { name, value } = event.target;
    setFormValues2((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  // Handle file upload
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    setPreviewUrl(URL.createObjectURL(file));

    const formData = new FormData();
    formData.append('image', file);

    try {
      const res = await AdminServices.updateMe(formData); // Assuming updateProfileImage is a method in AdminServices
      alert('Profile image updated successfully');
   console.log(res);
      localStorage.setItem('image', res?.data?.image);
      run(); // Refetch data after updating image
    } catch (error) {
      console.error('Failed to update profile image', error);
      alert('Failed to update profile image');
    }
  };

  // Handle form submission for personal details
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await AdminServices.updateMe(formValues);
      alert('Admin details updated successfully');
      run(); // Refetch data after updating
    } catch (error) {
      console.error('Failed to update Admin details', error);
      alert('Failed to update Admin details');
    }
  };

  // Handle form submission for password change
  const handleSubmit2 = async (event) => {
    event.preventDefault();
    try {
      if (formValues2.newPassword !== formValues2.confirmPassword) {
        alert('New password and confirm password do not match');
      } else if (formValues2.oldPassword === formValues2.newPassword) {
        alert('New password cannot be the same as the old password');
      } else {
        await AdminServices.updatePassword(formValues2);
        alert('Password updated successfully');
        // Optionally clear the password fields after submission
        setFormValues2({
          oldPassword: '',
          newPassword: '',
          confirmPassword: '',
        });
      }
    } catch (error) {
      console.error('Failed to update password', error);
      alert('Failed to update password');
    }
  };

  if (isLoading) {
    return <div className="loader design_loading">Loading...</div>;
  }

  if (error) {
    return <div>Error loading admin details</div>;
  }

  return (
    <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

<div className="my-auto">

  <h5 className="page-title fs-21 mb-1">Profile </h5>
  <nav>

    <ol className="breadcrumb mb-0">

      <li className="breadcrumb-item">
        <a href="javascript:void(0);">Home</a>
      </li>
      <li className="breadcrumb-item active" aria-current="page">
      Profile
      </li>
    </ol>
  </nav>
</div>
<div className="d-flex my-xl-auto right-content align-items-center">

  <div className="pe-1 mb-xl-0">

    <div className="sub-title-box-right d-flex" style={{ gap: 20 }}>
    
    </div>
  </div>
   </div>
</div>
    
      <div className="container-box p-0 profile-container py-0">
        <div className="profile-header">
          <div className="profile-img-outer">
            <img src={process.env.REACT_APP_URL + previewUrl} alt="Profile" />
            <input
              type="file"
              style={{ display: 'none' }}
              ref={fileInputRef}
              onChange={handleFileChange}
            />
            <button
              className="profile-upload-btn"
              onClick={() => fileInputRef.current.click()}
            >
              <i className="fa fa-pencil" />
            </button>
          </div>
        </div>
        <div className="container-box-inner profile-design table-reponsive-tabe">
          <div className="row">
            <div className="col-md-6">
              <div className="page-details profile-details">
                <h4>User details</h4>
                <form onSubmit={handleSubmit}>
                  <div className="input-field">
                    <label>Name<span className='red'>*</span></label>
                    <input
                      type="text"
                      name="name"
                      value={formValues.name}
                      onChange={handleInputChange}
                      className="form-control"
                    />
                  </div>
                  <div className="input-field">
                    <label>Phone<span className='red'>*</span></label>
                    <input
                      type="text"
                      name="mobileNo"
                      maxLength={10}
                      value={formValues.mobileNo}
                      onChange={handleInputChange}
                      className="form-control"
                    />
                  </div>
                  <div className="input-field">
                    <label>Email<span className='red'>*</span></label>
                    <input
                      type="email"
                      name="email"
                      value={formValues.email}
                      onChange={handleInputChange}
                      className="form-control"
                                     />
                  </div>
                  <button className="submit-green-btn">  Save Changes</button>
                </form>
              </div>
            </div>
            <div className="col-md-6">
              <div className="page-details profile-details">
                <h4>Change your password</h4>
                <form onSubmit={handleSubmit2}>
                  <div className="input-field">
                    <label>Old Password</label>
                    <input
                      type="password"
                      name="oldPassword"
                      value={formValues2.oldPassword}
                      onChange={handleInputChange2}
                      className="form-control"
                      placeholder="Enter old password"
                                  />
                  </div>
                  <div className="input-field">
                    <label>New Password</label>
                    <input
                      type="password"
                      name="newPassword"
                      value={formValues2.newPassword}
                      onChange={handleInputChange2}
                      className="form-control"
                      placeholder="Enter new password"
                                   />
                  </div>
                  <div className="input-field">
                    <label>Confirm password</label>
                    <input
                      type="password"
                      name="confirmPassword"
                      value={formValues2.confirmPassword}
                      onChange={handleInputChange2}
                      className="form-control"
                      placeholder="Confirm new password"
                                       />
                  </div>
                  <button className="list-banner-btn submit-green-btn">
                    Save Changes
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
